import {tripsAPI} from "../api";
import {CitiesListResponse, City, CountriesListResponse, Country} from "../types/geo";
import {Shop, ShopsListResponse} from "../types/shops";

export function fetchSelectorsCities(limit: number, offset: number, search?: string): Promise<Array<City>> {
    return tripsAPI.get<CitiesListResponse>(
        `selectors/cities/`,
        {
            params: {
                limit, offset, search
            }
        }
    ).then(
        (res) => {
            return Promise.resolve(res.data.results);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}


export function fetchSelectorsCountries(limit: number, offset: number, search?: string): Promise<Array<Country>> {
    return tripsAPI.get<CountriesListResponse>(
        `selectors/countries/`,
        {
            params: {
                limit, offset, search
            }
        }
    ).then(
        (res) => {
            return Promise.resolve(res.data.results);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}


export function fetchSelectorsShops(limit: number, offset: number, search?: string): Promise<Array<Shop>> {
    return tripsAPI.get<ShopsListResponse>(
        `selectors/shops/`,
        {
            params: {
                limit, offset, search
            }
        }
    ).then(
        (res) => {
            return Promise.resolve(res.data.results);
        },
        (error) => {
            return Promise.reject(error);
        },
    );
}
